import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';

export default function AppLayout() {
  return (
    <div style={styles.wrapper}>
      <Header />
      <main style={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}

const styles = {
  wrapper: {
    minHeight: '100vh',
    backgroundColor: '#f7f8fa',
  },
  main: {
    paddingTop: '76px',
    minHeight: '100vh',
  },
};